import { useRef, useState } from "react";
import { api } from "../lib/api";
import { MessageSquare, X, Send, Loader2, Sparkles } from "lucide-react";

const SUGGESTIONS = [
  "Chi è in forma?",
  "Chi ha la miglior differenza games?",
  "Chi è l'ultimo in classifica?",
];

export function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    { role: "ai", text: "Ciao! Chiedimi qualsiasi cosa sul campionato: classifica, risultati, forma dei giocatori…" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);

  const send = async (q) => {
    const question = (q ?? input).trim();
    if (!question || loading) return;
    setInput("");
    setMsgs((m) => [...m, { role: "user", text: question }]);
    setLoading(true);
    try {
      const { data } = await api.post("/chat", { question });
      setMsgs((m) => [...m, { role: "ai", text: data.answer }]);
    } catch {
      setMsgs((m) => [...m, { role: "ai", text: "Scusa, non riesco a rispondere ora. Riprova." }]);
    } finally {
      setLoading(false);
      setTimeout(() => scrollRef.current?.scrollTo(0, scrollRef.current.scrollHeight), 50);
    }
  };

  return (
    <>
      <button
        data-testid="chat-widget-toggle"
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-6 right-6 z-[90] w-14 h-14 rounded-full bg-gradient-to-br from-fuchsia-500 to-emerald-500 text-white flex items-center justify-center shadow-2xl shadow-fuchsia-500/30 hover:scale-105 transition-transform"
        aria-label="Assistente campionato"
      >
        {open ? <X className="w-6 h-6" /> : <MessageSquare className="w-6 h-6" />}
      </button>

      {open && (
        <div
          data-testid="chat-widget-panel"
          className="fixed bottom-24 right-6 z-[90] w-[92vw] max-w-sm h-[70vh] max-h-[560px] flex flex-col rounded-2xl overflow-hidden ap-glass border border-white/10 shadow-2xl"
        >
          <div className="px-4 py-3 border-b border-white/10 flex items-center gap-2 bg-slate-950/60">
            <Sparkles className="w-4 h-4 text-fuchsia-400" />
            <span className="font-display uppercase tracking-wide text-sm text-white">Assistente AI</span>
          </div>

          <div ref={scrollRef} className="flex-1 overflow-y-auto p-3 space-y-3">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div
                  className={`max-w-[85%] px-3 py-2 rounded-2xl text-sm leading-relaxed ${
                    m.role === "user"
                      ? "bg-emerald-500 text-slate-950 rounded-br-sm"
                      : "bg-slate-800 text-slate-100 rounded-bl-sm"
                  }`}
                >
                  {m.text}
                </div>
              </div>
            ))}
            {loading && (
              <div className="flex justify-start">
                <div className="bg-slate-800 text-slate-300 px-3 py-2 rounded-2xl rounded-bl-sm">
                  <Loader2 className="w-4 h-4 animate-spin" />
                </div>
              </div>
            )}
            {msgs.length === 1 && (
              <div className="flex flex-wrap gap-2 pt-1">
                {SUGGESTIONS.map((s) => (
                  <button
                    key={s}
                    onClick={() => send(s)}
                    className="text-xs px-2.5 py-1.5 rounded-full bg-slate-800 text-slate-300 hover:bg-slate-700 border border-white/5"
                  >
                    {s}
                  </button>
                ))}
              </div>
            )}
          </div>

          <form
            onSubmit={(e) => { e.preventDefault(); send(); }}
            className="p-3 border-t border-white/10 flex items-center gap-2 bg-slate-950/40"
          >
            <input
              data-testid="chat-input"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Scrivi una domanda…"
              className="flex-1 bg-slate-900 border border-slate-700 rounded-full px-4 py-2 text-sm text-slate-100 focus:outline-none focus:ring-1 focus:ring-fuchsia-500"
            />
            <button
              data-testid="chat-send"
              type="submit"
              disabled={loading || !input.trim()}
              className="w-9 h-9 rounded-full bg-fuchsia-500 hover:bg-fuchsia-400 text-white flex items-center justify-center disabled:opacity-50"
            >
              <Send className="w-4 h-4" />
            </button>
          </form>
        </div>
      )}
    </>
  );
}
